import CircleAlert from 'lucide-react/dist/esm/icons/circle-alert.mjs';
import CircleCheck from 'lucide-react/dist/esm/icons/circle-check.mjs';
import CircleX from 'lucide-react/dist/esm/icons/circle-x.mjs';
import type { JSX } from 'react';
import { Icon } from '../../Icon/Icon.js';
import type { IconProps } from '../../Icon/Icon.js';
import { classNames } from '../../lib/classNames.js';
import { filledCircleIcon } from './filledCircleIcon.css.js';

const icons = { error: CircleX, success: CircleCheck, warning: CircleAlert };
export function AlertIcon({
  kind,
  className,
  ...props
}: IconProps & { readonly kind: keyof typeof icons }): JSX.Element {
  return (
    <Icon
      glyph={icons[kind]}
      size={24}
      {...props}
      className={classNames(filledCircleIcon, className)}
    />
  );
}
